import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';
import { BreakpointData, BreakpointDataIn } from './types';

export const breakpointData = (dataIn: Partial<BreakpointDataIn> = null): BreakpointData => {
	const rd = new RecordData<BreakpointDataIn>(dataIn);

	const record: BreakpointData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		center: rd.useNewOrDefault<number>('center', 0),
		// absent on every breakpoint saved before the seam rule existed, and every one of those
		// was placed by a designer -- so the legacy default has to be hand-placed, not managed
		ruleManaged: rd.useNewOrDefault<boolean>('ruleManaged', false)
	};

	return record;
};
